/* */ 
'use strict';
Object.defineProperty(exports, "__esModule", {value: true});
exports.default = trim;
var _assertString = require('./util/assertString');
var _assertString2 = _interopRequireDefault(_assertString);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {default: obj};
}
function trim(str, chars) {
  (0, _assertString2.default)(str);
  var pattern = chars ? new RegExp('^[' + chars + ']+|[' + chars + ']+$', 'g') : /^\s+|\s+$/g;
  return str.replace(pattern, '');
}
module.exports = exports['default'];
